import { Link } from "react-router-dom"
import { useI18nContext } from "../../i18n/i18n-react"
import NotFoundSvg from "../../assets/404.svg?react"

const NotFound = () => {
  const { LL } = useI18nContext()
  return (
    <div className="flex flex-col h-full w-full items-center justify-around pb-10">
      <div className="grow flex flex-col justify-center items-center space-y-5">
        <NotFoundSvg />
        <div className="text-sm">{LL.notFound()}</div>
      </div>

      <Link to="/" className="w-[calc(100%-5rem)] bg-[#444444] py-2.5 text-center rounded text-white">
        {LL.backToHome()}
      </Link>
    </div>
  )
}

export default NotFound
